import { render, staticRenderFns } from "./CoveragePrintable.vue?vue&type=template&id=34eaf631&scoped=true"
import script from "./CoveragePrintable.vue?vue&type=script&lang=ts"
export * from "./CoveragePrintable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34eaf631",
  null
  
)

export default component.exports